(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2732],{

/***/ 34468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varNeutral300":"var(--tkww-union-color-neutral-300, #CACCD0)","var-sm-max":"767.98px","varSmMax":"767.98px","varSpUp8":"3rem","varSpUp1":"1.25rem","varSpUp2":"1.5rem","varSpUp6":"2.5rem","section":"section--78731"};

/***/ }),

/***/ 92625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varNeutral200":"var(--tkww-union-color-neutral-200, #E4E5E9)","var-md-max":"1023.98px","varMdMax":"1023.98px","var-xs-max":"479.98px","varXsMax":"479.98px","varSpUp1":"1.25rem","varSpUp3":"1.75rem","varSpDown3":"0.25rem","slideButton":"slideButton--b7a9e","carouselIndicators":"carouselIndicators--c75e8","carouselIndicator":"carouselIndicator--7a2e9","active":"active--247f3","secondaryPageControlDisplay":"secondaryPageControlDisplay--c4261"};

/***/ }),

/***/ 78762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-md-max":"1023.98px","varMdMax":"1023.98px","var-lg":"1024px","varLg":"1024px","var-xl":"1192px","varXl":"1192px","var-lg-max":"1191.98px","varLgMax":"1191.98px","varSpUp4":"2rem","varSpDown2":"0.5rem","varSpUp6":"2.5rem","varSpUp1":"1.25rem","varSpUp12":"4rem","varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","varFontSize700":"var(--tkww-union-typography-scale-700-font-size, 1.75rem)","varBoldFontWeight":"var(--tkww-union-typography-bold-font-weight, 500)","carouselTitle":"carouselTitle--eacdb","titleHeader":"titleHeader--5031b","simpleSlideContainer":"simpleSlideContainer--0ccf2","simpleSlideImage":"simpleSlideImage--a89c0","simpleSlideLinkComponent":"simpleSlideLinkComponent--d979e","simpleSlideText":"simpleSlideText--f392c","valuePropSlideContainer":"valuePropSlideContainer--c6fb0","valuePropImage":"valuePropImage--200df","valuePropTextOverlay":"valuePropTextOverlay--a26eb","valuePropHeading":"valuePropHeading--a7b34","valuePropBody":"valuePropBody--5a341","heroSlideContainer":"heroSlideContainer--8a571","heroDesktopImage":"heroDesktopImage--421d7","heroMobileImage":"heroMobileImage--30900","heroSlideTextOverlayContainer":"heroSlideTextOverlayContainer--aff0d","heroSlideTextBox":"heroSlideTextBox--78737","heroSlideCta":"heroSlideCta--aabd4","heroTextContainer":"heroTextContainer--7f5d5"};

/***/ }),

/***/ 22047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HomePageSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34468);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var HomePageSection = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().section),
        children: [
            " ",
            children,
            " "
        ]
    });
};


/***/ }),

/***/ 59195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ responsiveWidthFunction; }
/* harmony export */ });
var responsiveWidthFunction = function(param) {
    var width = param.width;
    if (width > 839) return 3;
    if (width > 599) return 2;
    return 1;
};


/***/ }),

/***/ 52732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SimpleSlide": function() { return /* binding */ SimpleSlide; },
  "default": function() { return /* binding */ bottom_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(72730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./components/Tracking/useTracking/useTracking.tsx
var useTracking = __webpack_require__(14160);
// EXTERNAL MODULE: ./modules/core/services/analytics/index.tsx
var analytics = __webpack_require__(92737);
// EXTERNAL MODULE: ./ui/ImageWrapper/ImageTKWW.tsx
var ImageTKWW = __webpack_require__(44030);
// EXTERNAL MODULE: ./ui/Link/Link.tsx
var Link = __webpack_require__(14964);
// EXTERNAL MODULE: ./ui/Typography/Typography.tsx
var Typography = __webpack_require__(22655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./components/Homepage/shared/containers.tsx
var containers = __webpack_require__(22047);
// EXTERNAL MODULE: ./components/Homepage/shared/helpers.ts
var helpers = __webpack_require__(59195);
;// CONCATENATED MODULE: ./components/Homepage/tk/data.tsx


var carouselSlideProductClickedProperties = {
    price: {},
    name: "homepage cta carousel item",
    product_id: "-1"
};
var shopbyStylesBaseAnalyticsProperties = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSlideProductClickedProperties), {
    list_id: "shop-designs-by-style"
});
var shopbyCategoriesBaseAnalyticsProperties = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSlideProductClickedProperties), {
    list_id: "shop-by-category"
});
var trendingDesignBaseAnalyticsProperties = {
    list_id: "trending-designs"
};
var isInRange = function(banner) {
    return !banner.startDate || !banner.endDate || banner.startDate <= new Date().toISOString() && banner.endDate > new Date().toISOString();
};
var ValuePropSlideData = [
    {
        heading: "Free Design Assistance",
        link: {
            title: "Start Personalizing",
            url: "/invitations/wedding"
        },
        body: "From updating fonts to custom colors, we can help bring your vision to life.",
        image: "https://media-api.xogrp.com/images/bb958079-bae6-4873-95c4-4cc5292cbd90"
    },
    {
        heading: "Matching Websites",
        link: {
            title: "Find Your Match",
            url: "https://www.theknot.com/gs/wedding-websites?vers=0"
        },
        body: "Coordinate your paper with a free wedding website to stay on theme.",
        image: "https://media-api.xogrp.com/images/08012b1d-1f1b-45ba-8b94-4847ac4b1b18"
    },
    {
        heading: "Easy Guest Addressing",
        link: {
            title: "Get Started",
            url: "/invitations/wedding"
        },
        body: "Save time and let us address your envelopes in any design you choose.",
        image: "https://media-api.xogrp.com/images/72f0aedc-9bb2-48be-880e-947a16f95280"
    }, 
];
var TrendingDesignsData = [
    {
        name: "Eucalyptus Frame Wedding Invitations",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//0826k/win/image-files/color-theme_wht/front/eucalyptus-frame-wedding-invitations.jpg",
        url: "/product/eucalyptus-frame-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "paper/product/eucalyptus-frame-wedding-invitations",
                price: 1.99,
                name: "Eucalyptus Frame Wedding Invitations",
                product_id: '10oYGRsE21A2oocnezyVIF"',
                category: "Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//0826k/win/image-files/color-theme_wht/hero/eucalyptus-frame-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "500d90d2-5d4e-4b3c-8d26-f0b04dddf419",
                variant: {
                    color: "White",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Nothing Fancy All-in-One Wedding Invitations",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//325k/aio/image-files/color-theme_wht/front/nothing-fancy-all-in-one-wedding-invitations.jpg",
        url: "/product/nothing-fancy-all-in-one-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/nothing-fancy-all-in-one-wedding-invitations",
                price: 1.79,
                name: "Nothing Fancy All-in-One Wedding Invitations",
                product_id: "2WI4POzpdHfcCssPGRea7e",
                category: "All-in-One Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//325k/aio/image-files/color-theme_wht/hero/nothing-fancy-all-in-one-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "afe7f38d-4c2a-4398-bcbb-cd899ff04b4d",
                variant: {
                    color: "White",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "All-in-One",
                    material: "Signature Light",
                    paper_color: "No Paper Color",
                    printing_options: "Both Recipient and Return Addresses"
                }
            })
        }
    },
    {
        name: "Glamorous Crown Monogram Crest Wedding Invitations by Bridgerton",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//835k/win/image-files/foil-theme_fgld/color-theme_grn/front/glamorous-crown-monogram-crest-wedding-invitations.jpg",
        url: "/product/glamorous-crown-monogram-crest-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/glamorous-crown-monogram-crest-wedding-invitations",
                price: 2.59,
                name: "Glamorous Crown Monogram Crest Wedding Invitations by Bridgerton",
                product_id: "4NgmePj3WiXJ6BxftrwvDc",
                category: "Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//835k/win/image-files/foil-theme_fgld/color-theme_grn/hero/glamorous-crown-monogram-crest-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "b2174323-dc35-4179-a029-7a9dd51e0507",
                variant: {
                    color: "Green",
                    flap_type: "No Flap Type",
                    foil_color: "Gold",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Our Date Save the Date Cards",
        image: "https://media-api.xogrp.com/images/f06eee20-5853-4260-9f91-af08388c3de4",
        url: "/product/our-date-save-the-date-cards",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/our-date-save-the-date-cards",
                name: "Our Date Save the Date Cards",
                category: "Save the Date Cards",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//786k/sdc/image-files/color-theme_grn/hero/our-date-save-the-date-cards.jpg",
                price: 1.29,
                product_id: "2MLURjD1HsN23oarkbRj8t",
                quantity: 100,
                sample: false,
                sku: "https://media-api.xogrp.com/images/f06eee20-5853-4260-9f91-af08388c3de4",
                variant: {
                    color: "Green",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Beloved Floral Wedding Invitations",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//0691k/win/image-files/color-theme_red/front/beloved-floral-wedding-invitations.jpg",
        url: "/product/beloved-floral-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "paper/product/beloved-floral-wedding-invitations",
                price: 1.99,
                name: "Beloved Floral Wedding Invitations",
                product_id: "7gpOcCi2H76hTVjKaaboHm",
                category: "Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//0691k/win/image-files/color-theme_red/hero/beloved-floral-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "014e1541-5298-426f-b658-e5e9a52b06e0",
                variant: {
                    color: "Red",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Opulences Wedding Invitations by Vera Wang",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//1177k/win/image-files/foil-theme_fgld/color-theme_wht/front/opulences-vera-wang-wedding-invitations.jpg",
        url: "/product/opulences-vera-wang-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/opulences-vera-wang-wedding-invitations",
                name: "Opulences Wedding Invitations by Vera Wang",
                category: "Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//1177k/win/image-files/foil-theme_fgld/color-theme_wht/hero/opulences-vera-wang-wedding-invitations.jpg",
                price: 3.09,
                product_id: "4cQQ89pRuf0SOelIRCQoc3",
                quantity: 100,
                sample: false,
                sku: "a282188e-af08-438f-b554-e5cba079acfe",
                variant: {
                    color: "White",
                    flap_type: "No Flap Type",
                    foil_color: "Gold",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Vintage Film All-in-One Wedding Invitations",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//172k/aio/image-files/color-theme_crm/front/vintage-film-all-in-one-wedding-invitations.jpg",
        url: "/product/vintage-film-all-in-one-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "paper/product/vintage-film-all-in-one-wedding-invitations",
                price: 1.79,
                name: "Vintage Film All-in-One Wedding Invitations",
                product_id: "79WC4GBMQHNnL3ibkWSBot",
                category: "All-in-One Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//172k/aio/image-files/color-theme_crm/hero/vintage-film-all-in-one-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "f0aa315a-c285-40e3-8c8e-c8b27ba030ff",
                variant: {
                    color: "Cream",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "All-in-One",
                    material: "Signature Light",
                    paper_color: "No Paper Color",
                    printing_options: "Both Recipient and Return Addresses"
                }
            })
        }
    },
    {
        name: "Vintage Nouveau Wedding Invitations",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//1051k/win/image-files/color-theme_grn/front/vintage-nouveau-wedding-invitations.jpg",
        url: "/product/vintage-nouveau-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/vintage-nouveau-wedding-invitations",
                price: 1.99,
                name: "Vintage Nouveau Wedding Invitations",
                product_id: "1KnPuIwpRdoAs4QC4EJPP6",
                category: "Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//1051k/win/image-files/color-theme_grn/hero/vintage-nouveau-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "1ab8c09e-ded6-4ab6-8a10-83b1c8451549",
                variant: {
                    color: "Green",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Simple Modern Wildflowers Wedding Invitations",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//995k/win/image-files/color-theme_org/front/simple-modern-wildflowers-wedding-invitations.jpg",
        url: "/product/simple-modern-wildflowers-wedding-invitations",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/simple-modern-wildflowers-wedding-invitations",
                price: 1.99,
                name: "Simple Modern Wildflowers Wedding Invitations",
                product_id: "6UG684TCgL1GOVwwejiScA",
                category: "Wedding Invitations",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//995k/win/image-files/color-theme_org/hero/simple-modern-wildflowers-wedding-invitations.jpg",
                sample: false,
                quantity: 100,
                sku: "f91f8d5d-284d-4cb4-9ee5-73f97a633987",
                variant: {
                    color: "Orange",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    },
    {
        name: "Corner Script Save The Date Cards",
        image: "https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//1413k/sdc/image-files/color-theme_blk/front/corner-script-save-the-date-cards.jpg",
        url: "/product/corner-script-save-the-date-cards",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingDesignBaseAnalyticsProperties), {
                url: "/paper/product/corner-script-save-the-date-cards",
                price: 1.29,
                name: "Corner Script Save The Date Cards",
                product_id: "2droJO3gRR6Nr4NFQNIybJ",
                category: "Save the Date Cards",
                image_url: "https://tkww-paper-designs.s3.amazonaws.com/master//1413k/sdc/image-files/color-theme_blk/hero/corner-script-save-the-date-cards.jpg",
                sample: false,
                quantity: 100,
                sku: "62852e53-d6cc-42bc-85e0-eebc9e2a0ed1",
                variant: {
                    color: "Black",
                    flap_type: "No Flap Type",
                    foil_color: "No Foil",
                    format: "Standard",
                    material: "Signature",
                    paper_color: "No Paper Color",
                    printing_options: "No Printing Options"
                }
            })
        }
    }, 
];
var CategoriesData = [
    {
        name: "Save The Dates",
        image: "https://media-api.xogrp.com/images/553f66fe-2ca8-4a30-8803-56733b8a07f4",
        url: "/save-the-dates/save-the-date-cards",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyCategoriesBaseAnalyticsProperties), {
                category: [
                    "Save The Dates"
                ],
                url: "/paper/save-the-dates/save-the-date-cards"
            })
        }
    },
    {
        name: "Invitations",
        image: "https://media-api.xogrp.com/images/bb015b0f-6825-4d75-9b76-bde6d528ac7d",
        url: "/invitations/wedding",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyCategoriesBaseAnalyticsProperties), {
                category: [
                    "Invitations"
                ],
                url: "/paper/invitations/wedding"
            })
        }
    },
    {
        name: "Ceremony & Reception",
        image: "https://media-api.xogrp.com/images/7c689fb6-7f98-4ac8-be51-8ada1f12b84f",
        url: "/ceremony-reception",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyCategoriesBaseAnalyticsProperties), {
                category: [
                    "Ceremony & Reception"
                ],
                url: "/paper/ceremony-reception"
            })
        }
    },
    {
        name: "Thank Yous",
        image: "https://media-api.xogrp.com/images/9d9a5ae4-a21d-4828-8a6d-157ec10843e5",
        url: "/thank-yous",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyCategoriesBaseAnalyticsProperties), {
                category: [
                    "Thank Yous"
                ],
                url: "/paper/thank-yous"
            })
        }
    },
    {
        startDate: "2023-09-26T08:00:00.000Z" || 0,
        endDate: "2024-01-31T08:00:00.000Z" || 0,
        name: "Holiday Cards",
        image: "https://media-api.xogrp.com/images/c332ffe5-6410-45c9-b136-be2fda8ecb17",
        url: "/holiday-cards",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyCategoriesBaseAnalyticsProperties), {
                category: [
                    "Holiday Cards"
                ],
                url: "/paper/holiday-cards"
            })
        }
    }, 
];
var StyleData = [
    {
        name: "Floral",
        image: "https://media-api.xogrp.com/images/b8f777e0-d5a4-49d0-a82e-16cdd8aa001e",
        url: "/invitations?styles=Floral",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Floral",
                category: [
                    "Floral"
                ]
            })
        }
    },
    {
        name: "Classic",
        image: "https://media-api.xogrp.com/images/97275beb-c1da-490f-a369-d33622743369",
        url: "/invitations?styles=Classic",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Classic",
                category: [
                    "Classic"
                ]
            })
        }
    },
    {
        name: "Rustic",
        image: "https://media-api.xogrp.com/images/a232d674-97aa-41d9-941e-a1d2543a3849",
        url: "/invitations?styles=Rustic",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Rustic",
                category: [
                    "Rustic"
                ]
            })
        }
    },
    {
        name: "Vintage",
        image: "https://media-api.xogrp.com/images/aa5a6086-9e8d-4f8d-ab01-609bb58dbcab",
        url: "/invitations?styles=Vintage",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Vintage",
                category: [
                    "Vintage"
                ]
            })
        }
    },
    {
        name: "Simple",
        image: "https://media-api.xogrp.com/images/4736f1ea-307a-44e0-a8f4-8cc29da6f182",
        url: "/invitations?styles=Simple",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Simple",
                category: [
                    "Simple"
                ]
            })
        }
    },
    {
        name: "Modern",
        image: "https://media-api.xogrp.com/images/8da03a59-b9e5-45e9-9f8c-92bdba59c1bb",
        url: "/invitations?styles=Modern",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Modern",
                category: [
                    "Modern"
                ]
            })
        }
    },
    {
        name: "Destination",
        image: "https://media-api.xogrp.com/images/f33de453-c312-4f19-8895-6820ec08691b",
        url: "/invitations?styles=Destination",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Destination",
                category: [
                    "Destination"
                ]
            })
        }
    },
    {
        name: "Bohemian",
        image: "https://media-api.xogrp.com/images/cb0d3ba3-9fa0-4500-ac17-96d39e164e3a",
        url: "/invitations?styles=Bohemian",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Bohemian",
                category: [
                    "Bohemian"
                ]
            })
        }
    },
    {
        name: "Funny",
        image: "https://media-api.xogrp.com/images/00d023d5-b53f-4525-a6e2-82c0036f533c",
        url: "/invitations?styles=Funny",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Funny",
                category: [
                    "Funny"
                ]
            })
        }
    },
    {
        name: "Beach",
        image: "https://media-api.xogrp.com/images/b74c9a9f-62db-420c-b773-0a98fa35cc77",
        url: "/invitations?styles=Beach",
        tracking: {
            clicked: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopbyStylesBaseAnalyticsProperties), {
                url: "/paper/invitations?styles=Beach",
                category: [
                    "Beach"
                ]
            })
        }
    }, 
];
var HomePageData = {
    trendingDesigns: TrendingDesignsData.filter(isInRange),
    categories: CategoriesData.filter(isInRange),
    styles: StyleData,
    valuePropData: ValuePropSlideData
};

// EXTERNAL MODULE: ./components/Homepage/tk/shared/secondary-carousel.tsx + 2 modules
var secondary_carousel = __webpack_require__(41988);
// EXTERNAL MODULE: ./components/Homepage/tk/styles.module.scss
var styles_module = __webpack_require__(78762);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Homepage/tk/bottom.section.tsx


















var CarouselTitle = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).carouselTitle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* PaperH2 */.Sp, {
            children: [
                " ",
                title,
                " "
            ]
        })
    });
};
var SimpleSlide = function(_param) {
    var hasProducts = _param.hasProducts, slideData = (0,_object_without_properties/* default */.Z)(_param, [
        "hasProducts"
    ]);
    var name = slideData.name, image = slideData.image, url = slideData.url, tracking = slideData.tracking, index = slideData.index;
    var trackingData = (0,useTracking/* useTracking */.r)();
    var onClickHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(hasProducts && (tracking === null || tracking === void 0 ? void 0 : tracking.clicked))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,analytics/* trackInteractionPromise */.pB)("Product Clicked", (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tracking.clicked), {
                                position: index
                            }), trackingData))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "simple-slide-primary-cta",
        onClick: onClickHandler,
        className: (styles_module_default()).simpleSlideContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                unoptimized: true,
                className: (styles_module_default()).simpleSlideImage,
                src: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.ZP, {
                className: (styles_module_default()).simpleSlideLinkComponent,
                href: url,
                isExternal: true,
                children: [
                    " ",
                    name,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* PaperBody1 */.nu, {
                className: (styles_module_default()).simpleSlideText,
                children: name
            })
        ]
    });
};
var ValuePropPanelSlide = function(props) {
    var heading = props.heading, body = props.body, link = props.link, image = props.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).valuePropSlideContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                unoptimized: true,
                className: (styles_module_default()).valuePropImage,
                width: 444,
                height: 523,
                src: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).valuePropTextOverlay,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).valuePropHeading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* PaperH3 */.v9, {
                            children: [
                                " ",
                                heading,
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).valuePropBody,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* PaperBody1 */.nu, {
                            children: body
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).valuePropLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.ZP, {
                            color: "secondary",
                            href: link.url,
                            children: [
                                " ",
                                link.title,
                                " "
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var SecondaryCarousel = function(param) {
    var slidesData = param.slidesData, title = param.title, _hasProducts = param.hasProducts, hasProducts = _hasProducts === void 0 ? false : _hasProducts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselTitle, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_carousel/* CarouselWithPageDots */._, {
                responsive: helpers/* responsiveWidthFunction */.Q,
                maxSlideWidth: 1000,
                minSlideWidth: 290,
                children: slidesData.map(function(slide, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSlide, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        index: index
                    }, slide), {
                        hasProducts: hasProducts
                    }), "".concat(slide.name));
                })
            })
        ]
    });
};
var TitleHeaderSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* HomePageSection */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* PaperH1 */.s2, {
            className: (styles_module_default()).titleHeader,
            children: "Wedding Invitations, Day of Stationery and Save the Dates, All Designed for You"
        })
    });
};
var ValuePropPanelCarouselContainer = function() {
    var valuePropData = HomePageData.valuePropData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* HomePageSection */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_carousel/* CarouselWithPageDots */._, {
            maxSlideWidth: 1000,
            minSlideWidth: 290,
            responsive: helpers/* responsiveWidthFunction */.Q,
            children: valuePropData.map(function(slide) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuePropPanelSlide, (0,_object_spread/* default */.Z)({}, slide), slide.heading);
            })
        })
    });
};
var StyleCarouselContainer = function() {
    var styles = HomePageData.styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* HomePageSection */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryCarousel, {
            slidesData: styles,
            title: "Shop designs by style"
        })
    });
};
var CategoryCarouselContainer = function() {
    var categories = HomePageData.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* HomePageSection */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryCarousel, {
            slidesData: categories,
            title: "Shop by category"
        })
    });
};
var TrendingDesignCarouselContainer = function() {
    var trendingDesigns = HomePageData.trendingDesigns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* HomePageSection */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryCarousel, {
            slidesData: trendingDesigns,
            title: "Check out these trending designs",
            hasProducts: true
        })
    });
};
var BottomSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleHeaderSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuePropPanelCarouselContainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleCarouselContainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCarouselContainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDesignCarouselContainer, {})
        ]
    });
};
/* harmony default export */ var bottom_section = (BottomSection);


/***/ }),

/***/ 41988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ CarouselWithPageDots; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-colors/lib/variables.css
var variables = __webpack_require__(49455);
var variables_default = /*#__PURE__*/__webpack_require__.n(variables);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/lib/Carousel/index.js + 3 modules
var Carousel = __webpack_require__(26968);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js
var IconButton = __webpack_require__(51197);
// EXTERNAL MODULE: ./components/Homepage/tk/shared/styles.module.scss
var styles_module = __webpack_require__(92625);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Homepage/tk/shared/buttons.tsx





var NextButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: "lg",
        name: "caret_right"
    }, props), {
        className: "".concat((styles_module_default()).slideButton, " ").concat(props.className)
    }));
};
var PrevButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: "lg",
        name: "caret_left"
    }, props), {
        className: "".concat((styles_module_default()).slideButton, " \n        ").concat(props.className)
    }));
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/Homepage/tk/shared/page-control.tsx




var PageControl = function(param) {
    var pages = param.pages, onPageSelected = param.onPageSelected, current = param.current, className = param.className, controlStateColors = param.controlStateColors;
    var dots = Array.from({
        length: pages
    }, function(_, i) {
        return i;
    });
    var ref = controlStateColors !== null && controlStateColors !== void 0 ? controlStateColors : {
        unselectedPageDot: (variables_default()).varWhite,
        selectedPageDot: (variables_default()).varBackgroundDark,
        hoverStateDotBorder: (variables_default()).varNeutral200
    }, unselectedPageDot = ref.unselectedPageDot, selectedPageDot = ref.selectedPageDot, hoverStateDotBorder = ref.hoverStateDotBorder;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        className: classnames_default()((styles_module_default()).carouselIndicators, className),
        children: dots.map(function(i, index) {
            var activeClass = current == index ? (styles_module_default()).active : "";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                onClick: function() {
                    return onPageSelected(index);
                },
                "aria-label": "".concat(index + 1, " of ").concat(pages),
                style: {
                    "--unselectedPageDot": unselectedPageDot,
                    "--selectedPageDot": selectedPageDot,
                    "--hoverStateDotBorder": hoverStateDotBorder
                },
                className: classnames_default()((styles_module_default()).carouselIndicator, activeClass)
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./components/Homepage/tk/shared/secondary-carousel.tsx









var CarouselWithPageDots = function(param) {
    var minSlideWidth = param.minSlideWidth, maxSlideWidth = param.maxSlideWidth, responsive = param.responsive, children = param.children;
    var ref = (0,react.useState)(0), navigationIndex = ref[0], setNavigationIndex = ref[1];
    var ref1 = (0,react.useState)(), navigationRange = ref1[0], setNavigationRange = ref1[1];
    var slides = react.Children.toArray(children);
    var onCarouselNavigationIndexChange = (0,react.useCallback)(function(nextNavigationIndex) {
        setNavigationIndex(nextNavigationIndex);
    }, []);
    var onCarouselNavigationRangeChange = (0,react.useCallback)(function(range) {
        setNavigationRange(range);
    }, []);
    var pages = (navigationRange === null || navigationRange === void 0 ? void 0 : navigationRange.max) ? (navigationRange === null || navigationRange === void 0 ? void 0 : navigationRange.max) + 1 : slides.length;
    var props = {
        minSlideWidth: minSlideWidth,
        maxSlideWidth: maxSlideWidth,
        responsive: responsive
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onNavigationIndexChange: onCarouselNavigationIndexChange,
                onNavigationRangeChange: onCarouselNavigationRangeChange,
                navigationIndex: navigationIndex,
                renderNextButton: NextButton,
                renderPrevButton: PrevButton,
                alignment: function() {
                    return "left";
                },
                gutter: 30
            }, props), {
                children: children
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageControl, {
                className: (styles_module_default()).secondaryPageControlDisplay,
                pages: pages,
                current: navigationIndex,
                onPageSelected: onCarouselNavigationIndexChange,
                controlStateColors: {
                    hoverStateDotBorder: (variables_default()).varNeutral200,
                    selectedPageDot: (variables_default()).varBackgroundDark,
                    unselectedPageDot: (variables_default()).varNeutral200
                }
            })
        ]
    });
};


/***/ }),

/***/ 92737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LW": function() { return /* binding */ trackInteraction; },
/* harmony export */   "pB": function() { return /* binding */ trackInteractionPromise; },
/* harmony export */   "tN": function() { return /* binding */ pageView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21170);
/* harmony import */ var _tracker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30380);




var pageView = function(props) {
    if (false) {}
    (0,_tracker__WEBPACK_IMPORTED_MODULE_0__/* .initializeTracking */ .e)();
    var page = window.analytics.page;
    page && page(props);
};
function mergeBaseOptions(props) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        section: "paper"
    });
}
var trackInteraction = function(event, properties) {
    (0,_tracker__WEBPACK_IMPORTED_MODULE_0__/* .initializeTracking */ .e)();
    var track = window.analytics.track;
    var integrations = (0,_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__/* .createAnalyticsIntegrations */ .zc)();
    track && track(event, mergeBaseOptions(properties), integrations);
};
var trackInteractionPromise = function(event, properties) {
    (0,_tracker__WEBPACK_IMPORTED_MODULE_0__/* .initializeTracking */ .e)();
    var track = window.analytics.track;
    var integrations = (0,_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__/* .createAnalyticsIntegrations */ .zc)();
    var trackCallPromise = new Promise(function(resolve) {
        track && track(event, mergeBaseOptions(properties), integrations, function() {
            resolve("".concat(event, " tracked"));
        });
    });
    var timeout = new Promise(function(resolve) {
        var id = setTimeout(function() {
            clearTimeout(id);
            resolve("Timeout of 3s");
        }, 3000);
    });
    return Promise.race([
        trackCallPromise,
        timeout
    ]);
};


/***/ }),

/***/ 44030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ ImageTKWW; }
/* harmony export */ });
/* unused harmony exports TRANSFORM_URL, CROP_URL, SIZES */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72730);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _modules_core_services_honeybadger_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69354);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96645);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55323);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99084);










var TRANSFORM_URL = "/transform~rs_";
var CROP_URL = "~sc_";
var shouldBuildSrc = function(path) {
    return path.indexOf("".concat("https://media-api.xogrp.com", "/images/fetch")) < 0;
};
var shouldTransform = function(path) {
    return !/~rs_/.test(path);
};
var appendTransform = function(param) {
    var src = param.src, oneSize = param.oneSize, crop = param.crop, width = param.width;
    if (oneSize && crop) {
        return "".concat(src).concat(TRANSFORM_URL).concat(oneSize, ".").concat(oneSize, "-fit").concat(CROP_URL).concat(oneSize);
    }
    if (oneSize) {
        return "".concat(src).concat(TRANSFORM_URL).concat(oneSize, ".h-fit");
    }
    if (crop) {
        return "".concat(src).concat(TRANSFORM_URL).concat(width, ".").concat(width, "-fit").concat(CROP_URL).concat(width, ".").concat(width);
    }
    return "".concat(src).concat(TRANSFORM_URL).concat(width, ".h-fit");
};
var SIZES = [
    {
        w: 640,
        size: 600
    },
    {
        w: 828,
        size: 600
    },
    {
        w: 1200,
        size: 900
    },
    {
        w: 1600,
        size: 1200
    },
    {
        w: 3840,
        size: 1200
    }, 
];
var ImageTKWW = function(_param) {
    var crop = _param.crop, oneSize = _param.oneSize, forceTransform = _param.forceTransform, noCache = _param.noCache, elementProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "crop",
        "oneSize",
        "forceTransform",
        "noCache"
    ]);
    var getSize = function(width) {
        var foundSize = SIZES.find(function(param) {
            var w = param.w;
            return width <= w;
        });
        return (foundSize === null || foundSize === void 0 ? void 0 : foundSize.size) || SIZES[SIZES.length - 1].size;
    };
    var loadImage = function(param) {
        var src = param.src, width = param.width;
        var url = src;
        if (shouldBuildSrc(src)) {
            url = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .buildSrc */ .ZA)(src);
        }
        if (oneSize) {
            if (shouldTransform(src)) {
                url = appendTransform({
                    src: url,
                    crop: crop,
                    oneSize: oneSize
                });
            }
        }
        var size = getSize(width);
        if (shouldTransform(src)) {
            url = appendTransform({
                src: url,
                crop: crop,
                width: size
            });
        }
        // media api will cache items by default, so we need to append a refetch query param
        // to avoid this behavior when caching is not desired
        if (noCache) {
            url = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .appendRefetch */ .tl)(url);
            url = "".concat(url, "&t=").concat(Date.now());
        }
        return url;
    };
    var ref;
    var width = (ref = oneSize !== null && oneSize !== void 0 ? oneSize : elementProps.width) !== null && ref !== void 0 ? ref : 1200;
    var ref1;
    var height = (ref1 = oneSize !== null && oneSize !== void 0 ? oneSize : elementProps.height) !== null && ref1 !== void 0 ? ref1 : 1200;
    var url = elementProps.src;
    if (forceTransform || shouldBuildSrc(elementProps.src)) {
        url = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .buildSrc */ .ZA)(elementProps.src);
        url = loadImage({
            src: String(url),
            width: parseInt("".concat(width))
        });
    }
    // this useEffect will conditionally re-fetch the src of the image with a no-cache header,
    // thus invalidating the browser cache
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function invalidateBrowserCache() {
            return _invalidateBrowserCache.apply(this, arguments);
        }
        function _invalidateBrowserCache() {
            _invalidateBrowserCache = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    try {
                        result = fetch(url.split("&")[0], {
                            method: "GET",
                            cache: "no-cache"
                        });
                    } catch (e) {
                        _modules_core_services_honeybadger_service__WEBPACK_IMPORTED_MODULE_7__["default"].notify("Unable to fetch proof image with no-cache header ".concat(url), {
                            name: "failedToInvalidateProofImageCache",
                            context: {
                                url: url
                            }
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return _invalidateBrowserCache.apply(this, arguments);
        }
        if (noCache) invalidateBrowserCache();
    }, [
        url,
        noCache
    ]);
    var _alt, _alt1;
    return noCache ? // there is currently no easy way to disable the next file system cache, so we use a raw img
    // tag when we want to avoid caching
    // eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, elementProps), {
        src: url,
        alt: (_alt = elementProps.alt) !== null && _alt !== void 0 ? _alt : "",
        width: width,
        height: height
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, elementProps), {
        src: url,
        loader: loadImage,
        width: width,
        height: height,
        alt: (_alt1 = elementProps.alt) !== null && _alt1 !== void 0 ? _alt1 : ""
    }));
};


/***/ }),

/***/ 14964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports Text, Icon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76806);
/* harmony import */ var _xo_union_tk_component_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21647);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15317);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _routing_externalApp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39313);
/* harmony import */ var _Link_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83593);
/* harmony import */ var _Link_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Link_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27555);
/* harmony import */ var _ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_4__);











var styles = (0,_utils_config__WEBPACK_IMPORTED_MODULE_5__/* .isTenant */ .J)("ww") ? (_ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_4___default()) : (_Link_module_scss__WEBPACK_IMPORTED_MODULE_3___default());
var DisabledLink = function(param) {
    var children = param.children, color = param.color, size = param.size;
    var className = classnames__WEBPACK_IMPORTED_MODULE_1___default()(styles.wrapper, styles[size], styles[color], styles.disabled);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        "data-testid": "disabled-link",
        className: className,
        children: children
    });
};
// It is needed an anchor wrapper for set styles to the component or wrap multiple child elements.
// The legacyBehavior and passHref props are necessary to have a functional component that returns an <a> tag as a child,
// see https://nextjs.org/docs/pages/api-reference/components/link#if-the-child-is-a-custom-component-that-wraps-an-a-tag).
var PaperLink = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "lg" : _size, _color = _param.color, color = _color === void 0 ? "primary" : _color, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = _param.onClick, children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, isExternal = _param.isExternal, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "size",
        "color",
        "disabled",
        "onClick",
        "children",
        "className",
        "isExternal"
    ]);
    if (!children) return null;
    if (disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DisabledLink, {
            color: color,
            size: size,
            children: children
        });
    }
    var anchorClassName = classnames__WEBPACK_IMPORTED_MODULE_1___default()(styles.wrapper, styles[size], styles[color], className);
    var link;
    if (isExternal) {
        var url = String(props.href).trim();
        //check if the url is a relative url and add a slash at the beginning
        if (!url.startsWith("/") && !url.startsWith("http")) {
            url = "/".concat(url);
        }
        url = (0,_routing_externalApp__WEBPACK_IMPORTED_MODULE_7__/* .getUrlToExternalApp */ .W)(url);
        link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            "data-testid": "external-link",
            href: url,
            className: anchorClassName,
            style: props.style,
            children: children
        });
    } else {
        link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
            href: String(props.href).startsWith("//") ? String(props.href).replace("//", "/") : props.href,
            legacyBehavior: true,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: anchorClassName,
                children: children
            })
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "link",
        className: styles.linkContainer,
        onClick: onClick,
        children: link
    });
};
var Text = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(styles.text, className)
    }, props), {
        children: children
    }));
};
var Icon = function(_param) {
    var name = _param.name, _size = _param.size, size = _size === void 0 ? "md" : _size, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "name",
        "size",
        "className"
    ]);
    if (!name) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_component_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        name: name,
        size: size,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(styles.icon, className)
    }, props));
};
PaperLink.Text = Text;
PaperLink.Icon = Icon;
/* harmony default export */ __webpack_exports__["ZP"] = (PaperLink);


/***/ })

}]);